import api, { genHeader } from './API'
import api_ext from './API-EXT'

export default {
  applyScreening(token: string, {
    creator_id,
    link_1,
    link_2,
    link_3,
    link_4,
    camera,
    software,
    remarks,
  }: any) {
    return api.post('/creator/applyScreening', {
      creator_id,
      link_1,
      link_2,
      link_3,
      link_4,
      camera,
      software,
      remarks,
    },
    genHeader(token))
  },

  getBankInfo(token: string) {
    return api.get('/creator/bankInfo', { ...genHeader(token) })
  },

  postBankInfo(token: string, data: any) {
    return api.post('/creator/bankInfo', data, genHeader(token))
  },

  changeEmail(data: any) {
    return api.post('/creator/changeEmail', data)
  },

  creatorAssociateSetting(data: any) {
    return api_ext.post('/creator/associate/setting', data)
  },

  creatorAssociateGetDeeplink(data: any) {
    return api_ext.post('/creator/associate/deeplink', data)
  },
}
